import $ from 'jquery';
import IdeaCommentForm, { AccessLevel } from './idea_comment';

describe('IdeaCommentForm', () => {
  afterEach(() => {
    $(document).off(); // remove all event handlers
  });

  function expectErrorsFor(comment, name) {
    expect(comment.find('.full-body').get(0)).toHaveClass('field-with-errors');
    expect(comment.find('.errors').text().trim()).toEqual(
      `Some message: ${name}`
    );
  }

  function expectNoErrorsFor(comment) {
    expect(comment.find('.full-body').get(0)).not.toHaveClass(
      'field-with-errors'
    );
    expect(comment.find('.errors .help-inline').text().trim()).toEqual('');
  }

  function triggerMention(element, access: AccessLevel) {
    element.trigger('editor:mention', [
      {
        id: '7300249709747985779',
        name: 'Alex',
        access,
      },
      'Some message: ',
    ]);
  }

  it('targets specific fields', () => {
    document.body.innerHTML = `
        <div class="idea-comment-new" id="new-comment">
          <div class="full-body"></div>
        </div>
        <div class="idea-comment-new" id="reply">
          <div class="full-body"></div>
        </div>`;

    const newComment = $('#new-comment');
    const replyComment = $('#reply');

    new IdeaCommentForm().init({
      target: '#reply',
      isReply: true,
      parentIsPrivate: true,
    });

    triggerMention(replyComment, AccessLevel.None);
    // No error element created for new comment
    expect(newComment.find('.errors').length).toEqual(0);

    expectNoErrorsFor(newComment);
    expectErrorsFor(replyComment, 'Alex');
  });

  describe('new comment', () => {
    beforeEach(() => {
      document.body.innerHTML = `
       <div class="idea-comment-new">
          <div class="full-body">
            <input type="checkbox" name="private-comment" value="1" checked />
          </div>
        </div>
      `;

      new IdeaCommentForm().init({
        target: '.idea-comment-new',
        isReply: false,
        privateSelector: '[name="private-comment"]',
      });
    });

    it('error if no access', () => {
      const root = $('.idea-comment-new');
      triggerMention(root, AccessLevel.None);
      expectErrorsFor(root, 'Alex');
    });

    it('error if public', () => {
      const root = $('.idea-comment-new');
      const rootElement = root.get(0);

      expect(rootElement).toBeTruthy();
      triggerMention(root, AccessLevel.Public);
      expectErrorsFor(root, 'Alex');
    });

    it('no error if private', () => {
      const root = $('.idea-comment-new');
      const rootElement = root.get(0);

      expect(rootElement).toBeTruthy();
      triggerMention(root, AccessLevel.Private);
      expectNoErrorsFor(root);
    });

    it('can be toggled', () => {
      const root = $('.idea-comment-new');

      triggerMention(root, AccessLevel.Public);
      expectErrorsFor(root, 'Alex');

      root.find('[name="private-comment"]').prop('checked', false);
      root.find('[name="private-comment"]').trigger('change');

      expectNoErrorsFor(root);
    });
  });

  describe('reply', () => {
    beforeEach(() => {
      document.body.innerHTML = `
       <div class="idea-comment-new">
          <div class="full-body"></div>
        </div>
      `;
    });

    describe('parent is private', () => {
      beforeEach(() => {
        new IdeaCommentForm().init({
          target: '.idea-comment-new',
          isReply: true,
          parentIsPrivate: true,
        });
      });

      it('error if no access', () => {
        const root = $('.idea-comment-new');
        triggerMention(root, AccessLevel.None);
        expectErrorsFor(root, 'Alex');
      });

      it('error if public', () => {
        const root = $('.idea-comment-new');
        triggerMention(root, AccessLevel.Public);
        expectErrorsFor(root, 'Alex');
      });

      // this case only happens when the mentioned user is the author, controlled by the backend
      it('no error if private', () => {
        const root = $('.idea-comment-new');
        triggerMention(root, AccessLevel.Private);
        expectNoErrorsFor(root);
      });
    });

    describe('parent is public', () => {
      beforeEach(() => {
        new IdeaCommentForm().init({
          target: '.idea-comment-new',
          isReply: true,
          parentIsPrivate: false,
        });
      });

      it('error if no access', () => {
        const root = $('.idea-comment-new');
        triggerMention(root, AccessLevel.None);
        expectErrorsFor(root, 'Alex');
      });

      it('no error if public', () => {
        const root = $('.idea-comment-new');
        triggerMention(root, AccessLevel.Public);
        expectNoErrorsFor(root);
      });

      it('no error if private', () => {
        const root = $('.idea-comment-new');
        triggerMention(root, AccessLevel.Private);
        expectNoErrorsFor(root);
      });
    });
  });
});
